import {FC} from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'

const maritalStatuses = [
  {id: 'married', name: '有'},
  {id: 'single', name: '無'},
]

export const MaritalStatuses: FC = () => {
  return (
    <MultiTagFilteringFieldRow
      header="配偶者の有無"
      name="maritalStatuses"
      list={withNull(maritalStatuses)}
      shouldUnregister
    />
  )
}
